// Interfaces
import { ITileSelectBox } from "../interfaces";

// Layouts
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// Icons
import PopupIcon from "@/assets/icons/svg/PopupIcon";

export default function TileSelectBox(props: Readonly<ITileSelectBox>) {
	const { data = [], selectBy = "_id", showBy = "label", sortBy = "value", readOnly = false, onChange = () => {} } = props;

	const handleSelect = (value: null) => {
		onChange?.(value);
	};

	return (
		<SmartSelector
			showAlways
			disablePortal
			selectBy={selectBy}
			showBy={showBy}
			sortBy={sortBy}
			options={data}
			selected={null}
			inputProps={{
				placeholder: "Search...",
				classes: "[&_.MuiInputBase-root>fieldset]:!rounded-[25px]",
			}}
			listBoxProps={{
				sx: { maxHeight: "100%" },
			}}
			paperProps={{
				avoidShadow: true,
			}}
			popupIconProps={{
				icon: <PopupIcon />,
			}}
			clearable
			disabled={readOnly}
			sx={{ position: "relative", marginTop: "10px" }}
			onChangeAction={(value) => handleSelect(value as null)}
		/>
	);
}
